import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { POST_SELECTED_WHEN } from "../../store/action";
import { dayPlusOne } from "../functions/dateFunctions";
import "../styles/layout.css";

import { configureCrisp } from "../../utils/crispConfig";
import SelectAcademy from "../elements/select_academy";

const LayoutAcademy = () => {

  let selectedWhen = useSelector((state) => state.selectedWhen);
  let selectedLang = useSelector((state) => state.lang);

  let userData = useSelector((state) => state.user);

  const dispatch = useDispatch();

  useEffect(() => {
    configureCrisp({
      autoload: true,
      lockMaximized: false,
      lockFullview: false
    });
    initialData();
  }, []);

  const initialData = async () => {
    const tday = dayPlusOne();
    if (selectedWhen === null || selectedWhen < tday) {
      WhenDate(tday);
    }

  };

  const WhenDate = (value) => dispatch(post_selected_when(value));

  return (
    <div className="global-block">
      <div className="full-block">
        <SelectAcademy lang={selectedLang} user={userData} />
      </div>
    </div>
  );
};

const post_selected_when = (data) => ({
  type: POST_SELECTED_WHEN,
  data: data
});

export default LayoutAcademy;
